import React, { useCallback, useEffect, useRef, useState } from "react";
import { UniversalSearchDialog } from "./UniversalSearchDialog";
import type { UniversalSearchProps } from "./types";

export function UniversalSearch({
  searchPeople,
  navItems,
  onNavigate,
  onAnalytics,
  iconMap,
  placeholder,
  peopleSectionLabel,
}: UniversalSearchProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    setIsOpen(true);
    onAnalytics?.("universal_search:bar_open");
  };

  const handleOpenRef = useRef(handleOpen);
  handleOpenRef.current = handleOpen;

  const handleClose = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key === "k") {
        e.preventDefault();
        if (!isOpen) handleOpenRef.current();
        else setIsOpen(false);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [isOpen]);

  return (
    <UniversalSearchDialog
      isOpen={isOpen}
      onClose={handleClose}
      navItems={navItems}
      searchPeople={searchPeople}
      onNavigate={onNavigate}
      onAnalytics={onAnalytics}
      iconMap={iconMap}
      placeholder={placeholder}
      peopleSectionLabel={peopleSectionLabel}
    />
  );
}
